<ng-container *ngIf="debtMonthlyPayment;else noData">
  <div class="card-header">
    <div class="grid-x">
      <div class="cell auto">
        <h4 appEllipsisWithTooltip [id]="'WIDGET_'.concat(widget.size)">{{"widget.name.".concat(widget.widgetName) | translate}}</h4>
      </div>
      <div *ngIf="widget.size === WidgetSize.LARGE" class="cell shrink">
        <span class="f-10 c-medium-gray padding-r-xs">
          <span class="fas fa-circle" style="{{'color:' + AMORTIZATION_COLOR}}"></span>
          {{ 'widget.debt-monthly-payments.amortization' | translate}}
        </span>
        <span class="f-10 c-medium-gray padding-r-xs">
          <span class="fas fa-circle c-fairways" style="{{'color:' + INTERESTS_COLOR}}"></span>
          {{ 'widget.debt-monthly-payments.interests' | translate}}
        </span>
      </div>
    </div>
  </div>

  <div *ngIf="!this.chart"
       class="d-block  text-center">
    {{'widget.debt-monthly-payments.no-data' | translate}}
  </div>

  <div *ngIf="this.chart" class="card-body vertical-center">
    <div *ngIf="widget.size === WidgetSize.LARGE" class="d-block padding-h">
      <div class="d-block margin-b-xs">
        <span (click)="onClickOnPreviousPayment()"
              [ngClass]="{'c-light-gray': isFirstPayment(),
                          'c-medium-gray': !isFirstPayment()}"
              [ngStyle]="{'pointer-events': isFirstPayment() ? 'none' : 'auto'}"
              class="cursor-hover fas fa-chevron-circle-left margin-r-xs"></span>
        <span class="c-dark-gray margin-r-xs" style="font-weight:500;">
          {{debtMonthlyPayment.monthLabel}}
        </span>
        <span (click)="onClickOnNextPayment()"
              [ngClass]="{'c-light-gray': isLastPayment(),
                          'c-medium-gray': !isLastPayment()}"
              [ngStyle]="{'pointer-events': isLastPayment() ? 'none' : 'auto'}"
              class="cursor-hover fas fa-chevron-circle-right"></span>
      </div>
      <div *ngIf="!hasNoMonthlyPayment()" class="grid-x">
          <div class="cell shrink">
            <div [chart]="chart" class="d-block margin-r" style="height: 96px;width:200px;"></div>
          </div>
          <div class="cell auto margin-r-xl">
            <div class="bg-gray-light padding-h padding-v margin-t-s" style="  border-radius: 4px; border-left: solid 5px {{AMORTIZATION_COLOR}};">
              <div class="grid-x">
                <div class="cell auto">
                  <div class="c-medium-gray float-left">{{'widget.debt-monthly-payments.amortization' | translate}}</div>
                  <div class="c-dark-gray font-bold float-right">{{amountFormatterService.format(debtMonthlyPayment.amortization, '0.0a')}}</div>
                </div>
              </div>
            </div>
            <div class="bg-gray-light padding-h padding-v margin-t-s" style="  border-radius: 4px; border-left: solid 5px {{INTERESTS_COLOR}};">
              <div class="grid-x">
                <div class="cell auto">
                  <div class="c-medium-gray float-left">{{'widget.debt-monthly-payments.interests' | translate}}</div>
                  <div class="c-dark-gray font-bold float-right">{{amountFormatterService.format(debtMonthlyPayment.interests, '0.0a')}}</div>
                </div>
              </div>
          </div>
        </div>
      </div>
      <div *ngIf="hasNoMonthlyPayment()" class="grid-x">
        <div class="cell" style="height: 96px; text-align: center;">
          <h4 class="c-medium-gray font-500 margin-t">{{'widget.debt-monthly-payments.no-payment' | translate}}</h4>
        </div>
      </div>
    </div>

    <div *ngIf="widget.size === WidgetSize.SMALL" class="d-block padding-h">
      <div class="d-block">
        <span (click)="onClickOnPreviousPayment()"
              [ngStyle]="{'visibility': isFirstPayment() ? 'hidden' : 'visible'}"
              class="cursor-hover fas fa-arrow-alt-circle-left padding-r-xs c-medium-gray"></span>
        <span class="c-dark-gray margin-b-xs i-block" style="font-weight:500;">
          {{debtMonthlyPayment.monthLabel}}
        </span>
        <span (click)="onClickOnNextPayment()"
              [ngStyle]="{'visibility': isLastPayment() ? 'hidden' : 'visible'}"
              class="cursor-hover fas fa-arrow-alt-circle-right padding-l-xs c-medium-gray"></span>
      </div>
      <div *ngIf="!hasNoMonthlyPayment()"
           [chart]="chart" class="d-block"
           style="height: 96px;width: 100%; margin: auto"></div>
      <div *ngIf="hasNoMonthlyPayment()" class="grid-x">
        <div class="cell" style="height: 96px; text-align: center;">
          <h4 class="c-medium-gray font-500 margin-t">{{'widget.debt-monthly-payments.no-payment' | translate}}</h4>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="this.chart" class="card-footer">
    <a (click)="actionEvent.emit(getProcessPaymentOrdersLabel())" [href]="getProcessPaymentOrdersUrl()"
       class="button insito">
      <span [title]="getProcessPaymentOrdersLabel()">
        {{getProcessPaymentOrdersLabel()}}
      </span>
    </a>
  </div>
</ng-container>
<ng-template #noData>
  <app-widget-message [message]="'widget.debt-monthly-payments.no-payment-for-this-year'| translate"
                      [widgetLabel]="'widget.name.'.concat(widget.widgetName) | translate"
                      [widgetSize]="widget.size"
                      icone="opt-time"></app-widget-message>
</ng-template>
